































































import { Component, Mixins, Watch } from 'vue-property-decorator';
import {
  Select,
  Option,
  OptionGroup
} from 'element-ui';

// types
import {
  fetchTasks,
  TaskScopedInput,
  TaskOrderEnum,
  TaskFilterEnum,
  CustomerOrganizationFields,
  OperatorFields,
  fetchCustomerOrganizations
} from '@/types/graphql/schemaTypes';

// components
import NavBar from '@/components/layout/NavBar.vue';
import Pagination from '@/mixins/pagination';
import TasksList from '@/components/task/TasksList.vue';

// apollo
import { ApolloQueryResult } from 'apollo-client';
import { SelectOption } from '@/types/types';

// gql
import fetchCustomerOrganizationsQuery from '@/graphql/queries/FetchCustomerOrganizations.gql';
import fetchTasksQuery from '@/graphql/queries/FetchTasks.gql';
import filterListQuery from '@/graphql/queries/operator/FilterList.gql';

interface ElementSelectGroup {
  label: string;
  options: SelectOption<string>[];
}

@Component({
  components: {
    NavBar,
    TasksList,
    'el-select': Select,
    'el-option': Option,
    'el-option-group': OptionGroup
  },
  apollo: {
    tasks: {
      query: fetchTasksQuery,
      prefetch: true,
      variables() {
        const searchArgs: TaskScopedInput = {} as TaskScopedInput;

        if (this.customerOrganizationsFilter) {
          searchArgs.customerOrganizationId = this.customerOrganizationsFilter;
        }
        if (this.operatorFilter) {
          searchArgs.operatorId = this.operatorFilter;
        }
        return {
          searchArgs,
          ordering: TaskOrderEnum.DEADLINE_ASC,
          filter: this.statusFilter,
          pagination: {
            page: parseInt(this.$route.query.page, 10) || this.currentPage,
            per: parseInt(this.$route.query.size, 10) || this.paginationSize
          }
        };
      },
      update(data) {
        this.totalCount = data ? data.tasksPagination.totalCount : 0;
        return data && data.tasks;
      },
      fetchPolicy: 'cache-and-network',
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    },
    operators: {
      query: filterListQuery,
      prefetch: true,
      fetchPolicy: 'cache-and-network',
      update(data) {
        this.operatorOptions = this.formatOperatorFilters(data.operators);
        return data.operators;
      }
    },
    customerOrganizations: {
      query: fetchCustomerOrganizationsQuery,
      prefetch: true,
      variables() {
        return {
          customerOrganizationArgs: {
            name: this.search
          },
          pagination: {
            page: 1,
            per: 25
          }
        };
      },
      debounce: 1500,
      fetchPolicy: 'cache-and-network',
      error() {
        this.$store.dispatch('Alert/addAlert', {
          type: 'error',
          message: this.$t('error.fetch'),
          time: 3000
        });
      }
    }
  }
})
export default class Tasks extends Mixins(Pagination) {
  private customerOrganizationsFilter: string | null = null;
  private customerOrganizationsOptions: SelectOption<string>[] = [];
  public operatorFilter = '';
  public operatorOptions: ElementSelectGroup[] = [];
  public statusFilter: TaskFilterEnum = TaskFilterEnum.NOT_DONE;
  public statusOptions: SelectOption<string>[] = [];

  private search = '';

  public created() {
    this.statusOptions = Object.values(TaskFilterEnum).map((filter) => {
      return { label: this.$t(`tasks.filters.${filter}`) as string, value: filter };
    });
  }

  private formatOperatorFilters(operators: OperatorFields[]) {
    const searchedOperators = operators.map((operator: OperatorFields) => {
      return {
        label: operator.name || '',
        value: operator.id
      };
    }).filter((op) => {
      return op.value !== this.$store.state.User.profile.id;
    });
    return [
      {
        label: '',
        options: [
          { value: '', label: this.$t('inquiry.filter.all-operators') as string },
          { value: 'mine', label: this.$t('inquiry.filter.mine') as string },
          { value: 'unassigned', label: this.$t('inquiry.filter.unassigned') as string }
        ]
      },
      {
        label: this.$t('inquiry.filter.operators') as string,
        options: searchedOperators
      }
    ];
  }

  private searchCustomerOrganizations(search: string): void {
    this.search = search;
  }

  @Watch('customerOrganizations')
  setCustomerOrganizations(customerOrganizations: CustomerOrganizationFields[]) {
    this.customerOrganizationsOptions = customerOrganizations.map(
      (c: CustomerOrganizationFields) => {
        return { value: c.id, label: c.name || '' };
      });
  }

  @Watch('customerOrganizationsFilter')
  @Watch('operatorFilter')
  refreshTasks() {
    this.$apollo.queries.tasks.refetch();
  }
}
